import { CircularProgress } from "@mui/material";
import useMobile from "../../hooks/useOrientation";
export const CenteredLoader = () => {
  const isMobile = useMobile();
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "40vh",
      }}
    >
      <CircularProgress />
    </div>
  );
};
